import { render } from "./list-detail-panel.vue?vue&type=template&id=2d978596&scoped=true&ts=true"
import script from "./list-detail-panel.vue?vue&type=script&lang=ts"
export * from "./list-detail-panel.vue?vue&type=script&lang=ts"

import "./list-detail-panel.vue?vue&type=style&index=0&id=2d978596&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d978596"]])

export default __exports__